<template>
  <div class="wrap">
    <p class="line clear"></p>
    <div class="nav">
      <p class="navTitle clear">往届回顾</p>
      <p class="navDesc clear">REVIEW OF PREVIOUS SESSIONS</p>
      <Btn :navArr="IscReview_2023" :stopId="6" :style="styleBtn" @fetchNav="fetchNav" />
      <ul class="list">
        <li class="listLi" v-for="item in IscReview_2023" :key="item.id">
          <img class="listLiItr" :src="item.pic" alt="介绍图" />
          <div class="listLiNav">
            <p class="listLiNavTitle clear">
              {{ item.title }}
              <span class="listLiNavTime">{{ item.time }}</span>
            </p>
            <p class="listLiNavDesc clear">{{ item.desc }}</p>
          </div>
          <img
            class="listLiTag"
            src="https://s2.ssl.qhres2.com/static/9d46709069b428df.svg"
            alt="历史回顾点"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { IscReview_2023 } from '@/mock/2023isc/data.js'
import Btn from '@/components/common/2023/button.vue'
const styleBtn = {
  position: 'absolute',
  right: '14%',
  top: '25px'
}
function fetchNav(newId) {
  const listDom = document.getElementsByClassName('list')
  listDom[0].style.left = `-${newId * 294}px`
}
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.wrap {
  position: relative;
  width: 100%;
  min-width: 1280px;
  height: 1000px;
  padding-top: 100px;

  background: url('https://p2.ssl.qhimg.com/t01f822425044a702a7.png') no-repeat;
  background-size: cover;
  overflow: hidden;
}
.nav {
  width: 100%;
  margin: auto;
  // background-color: aqua;
  position: absolute;
  // background-color: yellow;
  left: 0;
  &Title {
    font-size: 40px;
    font-weight: bold;
    line-height: 32px;
    color: #ffffff;
    margin-left: 14%;
  }
  &Desc {
    font-size: 28px;
    line-height: 32px;
    color: #ffffff;
    margin-top: 12px;
    margin-bottom: 136px;
    margin-left: 14%;
  }
}
.line {
  position: absolute;
  top: 574px;
  width: 100%;
  border-bottom: 1px dashed #00ab7a;
}
.list {
  position: absolute;
  left: 0;
  white-space: nowrap;
  margin: 0;
  right: 0;
  // background-color: #00ab7a;
  // background-color: yellow;
  overflow: hidden;

  &Li {
    display: inline-block;
    list-style: none;
    width: 322px;
    margin-bottom: 30px;
    margin-left: 240px;
    border: 1px solid transparent;
    // background-color: red;

    &Tag {
      width: 24px;
      height: 24px;
      margin-top: 21px;
      left: -320px;
    }
    &Itr {
      width: 100%;
      height: 180px;
    }
    &Nav {
      background: #0a6857;

      &Title {
        font-size: 18px;
        font-weight: bold;
        line-height: 26px;
        color: #ffffff;
        padding: 11px 10px;
      }
      &Time {
        float: right;
        font-size: 14px;
        line-height: 22px;
        color: rgba(255, 255, 255, 0.5);
      }
      &Desc {
        float: left;
        min-height: 292px;
        visibility: hidden;
        background: #0a6857;
        padding: 7px 16px 69px;
        font-size: 14px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.8);
        white-space: pre-wrap;
        z-index: 1;
      }
    }
  }
  &Li:nth-child(odd) {
    position: absolute;
    top: 0px;
  }

  &Li:nth-child(even) {
    transform: translateX(285px);
    top: 294px;
    .listLiTag:nth-child(odd) {
      margin-top: -550px;
    }
  }
  &Li:nth-child(odd):hover {
    border: 1px solid #fff;
    z-index: 1;
    .listLiNavDesc {
      visibility: visible;
    }
  }
  &Li:nth-child(even):hover {
    border: 1px solid #fff;
    z-index: 1;
    top: 1px;
    z-index: 10;
    .listLiNavDesc {
      visibility: visible;
    }
  }
}
</style>
